import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import DifferentiatorsSection from '../components/DifferentiatorsSection';

export default function AboutPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <div className="section-eyebrow">About IronQuill</div>
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Supporting Government Contractors from Capture to Submission</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              IronQuill helps organizations strengthen their competitive position through strategic capture support, proposal development, and disciplined review processes. Whether supporting a single opportunity or serving as an extension of your proposal team, we provide the expertise and flexibility needed to pursue opportunities with confidence.
            </p>
          </div>
        </div>
      </section>

      <DifferentiatorsSection />
      
      <section className="section section-light">
        <div className="section-content">
          <div style={{ textAlign: 'center' }}>
            <h2 style={{ marginBottom: '24px' }}>Ready to Transform Your Proposal Process?</h2>
            <Link to="/contact" className="btn-primary">Get Started Today</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
